export default __webpack_public_path__ + "static/media/qar.834b81b6.png";